import {Activity, ActivityType} from '../activity';
import {Observable} from 'rxjs';
import {LazyDialogService} from './lazy-dialog.service';
import * as convert from 'xml-js';

export class CustomActivity extends Activity {
  constructor(lazyDialogService: LazyDialogService) {
    super(lazyDialogService, ActivityType.Custom);
  }

  public xml: string = '';

  public objForXML(): any[] {
    try {
      const obj = convert.xml2js(this.xml, {attributesKey: '$'});
      if (Array.isArray(obj.elements) && obj.elements.length > 0) {
        return obj.elements;
      } else {
        return [];
      }
    } catch (e) {
      return [];
    }
  }

  get isUnknown(): boolean {
    return true;
  }

  openDialog(): Observable<any> {
    return this.openDialogLazy('custom', this.dialogConfig);
  }
}
